import { render, staticRenderFns } from "./Surgeries.vue?vue&type=template&id=7b804888&"
import script from "./Surgeries.vue?vue&type=script&lang=js&"
export * from "./Surgeries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports